import { Card, Col, CardBody } from "reactstrap";
import StudentValidationFormCardBody from "./StudentValidationFormCardBody";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { StudentValidationFormHeading } from "../../../../Constant";
import { STUDENT_VALIDATION_DATA } from "../../../../Data/FormLayout";

const StudentValidationForm = () => {
  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={StudentValidationFormHeading} span={STUDENT_VALIDATION_DATA}/>
        <CardBody className="custom-input">
          <StudentValidationFormCardBody />
        </CardBody>
      </Card>
    </Col>
  );
};

export default StudentValidationForm;
